import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { storeCreator, initialState } from "./Store";
import {
  decodeBrowserPathToState,
  saveBrowserLocation,
} from "./common/actions";
import {
  startBrowserHistoryListener,
  getLocation,
  hist,
} from "./common/services/BrowserLocation";
import { basePath } from "./config";
import App from "./containers/App";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material";
import PFATheme from "./PFATheme";
import { ConnectedRouter } from "connected-react-router";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// set up the initial store
const store = storeCreator(initialState);

// establish listener to apply changes from back-button, etc.
startBrowserHistoryListener(store, basePath, decodeBrowserPathToState);

//Only require react-axe (accessibility tool) in non-prod
if (
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_DISABLE_AXE !== "true"
) {
  var axe = require("react-axe");
  axe(React, ReactDOM, 1000);
}

class BankFind extends React.Component {
  public render() {
    store.dispatch(saveBrowserLocation(getLocation().pathname));

    // look for any data in the URL to use to set initial state
    if (getLocation().search) {
      // use the supplied URL params if available
      // decodeBrowserPathToState also in turn triggers fetchResults
      store.dispatch(
        decodeBrowserPathToState(store, getLocation().search) as any,
      );
    }
    return (
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={PFATheme}>
            <div id="main-content">
              <ConnectedRouter history={hist}>
                <App />
              </ConnectedRouter>
            </div>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    );
  }
}

ReactDOM.render(<BankFind />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
